import { render, staticRenderFns } from "./SignCard.vue?vue&type=template&id=ff4c1dde&"
import script from "./SignCard.vue?vue&type=script&lang=ts&"
export * from "./SignCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports